// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".status-badge {\n    padding-top: 0.4em;\n    padding-bottom: 0.4em;\n    width: 7em;\n    text-align: center;\n}\n\n.status-badge.outline{\n    background: transparent;\n    border-style: solid;\n    border-width: 1px;\n}\n\n.status-badge.outline.badge-success{\n    color: #6bd098;\n}\n.status-badge.outline.badge-warning{\n    color: #ffc107;\n}\n.status-badge.outline.badge-danger{\n    color: #dc3545;\n}", ""]);
// Exports
module.exports = exports;
